export enum DataTypeEnum {
  STRING = 'string'
}
